import { CircularProgress } from "@mui/material";
import React from "react";
import { twMerge } from "tailwind-merge";

const variants = {
	primary: "bg-primary-yellow text-primary-gray-20 border-none",
	secondary:
		"bg-transparent text-primary-yellow border border-solid border-primary-yellow",
	rectangularPrimary:
		"bg-primary-yellow text-primary-gray-20 border-none rounded-[10px]",
	rectangularSecondary:
		"bg-transparent text-primary-yellow border border-solid border-primary-yellow rounded-[10px]",
};

const AppButton = ({
	children,
	className = "",
	isLoading = false,
	variant = "primary",
	locked = null,
	unlocked = null,
	progressSize = 30,
	...rest
}) => {
	// Add "relative" so that the overlay can be positioned absolutely inside the button.
	const commonClasses =
		"relative h-auto disabled:bg-disabled-gray disabled:cursor-not-allowed disabled:text-primary-gray-20 disabled:border-none rounded-[115px] w-fit text-black font-normal text-sm md:text-base px-4 py-[6px] cursor-pointer";
	return (
		<button
			className={twMerge(commonClasses, variants[variant], className)}
			{...rest}>
			{isLoading ? (
				<CircularProgress size={progressSize} />
			) : (
				<span>{children}</span>
			)}
			{locked && (
				<span className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-red-500 h-[32px] w-8 rounded-r-[20px] flex items-center justify-center">
					<img
						src="/Assets/Icons/white-lock.svg"
						alt="locked"
						className="w-4 h-4 object-cover mb-1"
						style={{ opacity: 0.8 }}
					/>
				</span>
			)}
			{unlocked && (
				<span className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-[#3a3a3a] h-[32px] w-8 rounded-r-[20px] flex items-center justify-center">
					<img
						src="/Assets/Icons/lock_open_right.svg"
						alt="locked"
						className="w-4 h-4 object-cover mb-1 ml-[-4px]"
						style={{ opacity: 0.8 }}
					/>
				</span>
			)}
		</button>
	);
};

export default AppButton;
